import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiUsers } from 'react-icons/fi';
import { Dropdown } from '@/components/custom/dropdown/dropdown';
import moment from 'moment';
import usePermission from '@/hooks/usePermission';
import { confirm } from '@/lib/confirm';
import { t } from 'i18next';
import { PiStudent } from 'react-icons/pi';
import { ButtonGroup } from '@/components/ui/button-group';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export default function ClassroomCard(props) {
  const { classroom, editClassroomForm, deleteClassroom, setIsEditing } = props;

  const date = classroom && classroom['end-date'];

  const handleEdit = () => {
    setIsEditing(true);
    editClassroomForm(classroom);
  };

  return (
    <div className="card">
      <div className="card__container">
        <span className="card__icon-wrapper card__icon-wrapper--sm">
          <PiStudent className="card__icon card__icon--md" />
        </span>

        <div className="card__content">
          <div className="card__header">
            <div className="card__inner-header">
              <h3
                className="card__title"
                title={classroom?.title}
              >
                {classroom?.title}
              </h3>
            </div>

            <div className="expanded-calendar__tag expanded-calendar__tag--course">{classroom?.institution?.name}</div>
            <div className="expanded-calendar__tag expanded-calendar__tag--course">{classroom?.course?.title}</div>
          </div>

          <div className="card__body">
            <div className="card__columns">
              {date && (
                <p className="card__info">
                  <span>{t('textsCommon.availableUntil')}:</span> {moment(date).format('DD/MM/YYYY')}
                </p>
              )}
              <div className="card__count">
                <span className="card__count-label">{t('classes.participants')}</span>
                <FiUsers
                  size={20}
                  className="text-primary"
                />{' '}
                {(Number(classroom?.['manager-count']) || 0) + (Number(classroom?.['student-count']) || 0)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card__footer">
        <ButtonGroup className="w-full">
          {usePermission('Visualizar lista de turmas', 'Turmas') && (
            <Button
              variant="outline"
              size="sm"
              fullWidth
              asChild
            >
              <Link
                to={`/turmas/gerenciar/${classroom.id}`}
                type="button"
                className="btn btn--outline btn--small"
              >
                {t('textsCommon.participants')}
              </Link>
            </Button>
          )}

          {usePermission('Editar turmas', 'Turmas') || usePermission('Excluir turmas', 'Turmas') ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                >
                  <FiChevronDown size={20} />
                </Button>
              </DropdownMenuTrigger>

              <DropdownMenuContent align="end">
                {usePermission('Editar turmas', 'Turmas') && <DropdownMenuItem onClick={handleEdit}>{t('button.edit')}</DropdownMenuItem>}
                {usePermission('Excluir turmas', 'Turmas') && (
                  <DropdownMenuItem
                    onClick={async () => {
                      const confirmed = await confirm({
                        title: t('projects.warningDeleteClass'),
                        description: t('projects.warningDeleteCannotBeUndoneText'),
                        confirmText: t('button.yes'),
                        cancelText: t('button.no')
                      });
                      if (confirmed) {
                        deleteClassroom(classroom);
                      }
                    }}
                  >
                    {t('button.delete')}
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          ) : null}
        </ButtonGroup>
      </div>
    </div>
  );
}
